import { useMemo } from 'react'

export const useBroadcastChannel = (name: string) =>
  useMemo(() => new BroadcastChannel(name), [name])
